// Auto-generated file - DO NOT EDIT MANUALLY
// Generated on: 2025-11-18T12:57:36.701Z
// Run 'npm run generate:constants' to regenerate

export const N5KanjiLength = 80;
export const N4KanjiLength = 167;
export const N3KanjiLength = 370;
export const N2KanjiLength = 374;
export const N1KanjiLength = 1504;

export const N5VocabLength = 684;
export const N4VocabLength = 640;
export const N3VocabLength = 1730;
export const N2VocabLength = 1812;
export const N1VocabLength = 3427;
